/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Confirm_Checkin_BtnInputs */

const en_rental_confirm_checkin_btn = /** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Check-In`)
};

const es_rental_confirm_checkin_btn = /** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar Check-In`)
};

const fr_rental_confirm_checkin_btn = /** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer l'arrivée`)
};

const de_rental_confirm_checkin_btn = /** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in bestätigen`)
};

const id_rental_confirm_checkin_btn = /** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfirmasi Check-In`)
};

/** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */
const ja_rental_confirm_checkin_btn = en_rental_confirm_checkin_btn;

/** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */
const zh_rental_confirm_checkin_btn = en_rental_confirm_checkin_btn;

/** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */
const ar_rental_confirm_checkin_btn = en_rental_confirm_checkin_btn;

/** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */
const it_rental_confirm_checkin_btn = en_rental_confirm_checkin_btn;

/** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */
const ru_rental_confirm_checkin_btn = en_rental_confirm_checkin_btn;

/** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */
const pt_rental_confirm_checkin_btn = en_rental_confirm_checkin_btn;

/** @type {(inputs: Rental_Confirm_Checkin_BtnInputs) => LocalizedString} */
const ko_rental_confirm_checkin_btn = en_rental_confirm_checkin_btn;

/**
* | output |
* | --- |
* | "Confirm Check-In" |
*
* @param {Rental_Confirm_Checkin_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_confirm_checkin_btn = /** @type {((inputs?: Rental_Confirm_Checkin_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Confirm_Checkin_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_confirm_checkin_btn(inputs)
	if (locale === "es") return es_rental_confirm_checkin_btn(inputs)
	if (locale === "fr") return fr_rental_confirm_checkin_btn(inputs)
	if (locale === "de") return de_rental_confirm_checkin_btn(inputs)
	if (locale === "ja") return ja_rental_confirm_checkin_btn(inputs)
	if (locale === "zh") return zh_rental_confirm_checkin_btn(inputs)
	if (locale === "ar") return ar_rental_confirm_checkin_btn(inputs)
	if (locale === "id") return id_rental_confirm_checkin_btn(inputs)
	if (locale === "it") return it_rental_confirm_checkin_btn(inputs)
	if (locale === "ru") return ru_rental_confirm_checkin_btn(inputs)
	if (locale === "pt") return pt_rental_confirm_checkin_btn(inputs)
	return ko_rental_confirm_checkin_btn(inputs)
});